"use client";

import { FC, useEffect, useState } from "react";
import { Spin } from "antd";
import { setAuth, setProfileAndContact, sigOut } from "store/slices/authSlice";
import { useAppDispatch } from "store";
import { useParams, useNavigate } from "react-router-dom";
import { getAuthProfile } from "services/authAPI";
import { getFactoryByAdmin } from "services/factoryAPI";

const AuthAdmin: FC = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { key, factory, menu, item } = useParams();
    const [isLoading, setIsLoading] = useState(true);

    const handlePage = (menu: string, item: string) => {
        switch (menu) {
            case 'order':
                navigate(`/order/`);
                break;
            case 'order_by_id':
                console.log('item', item);
                navigate(`/order/${item}`);
                break;
            case "product":
                navigate(`/manage-product/edit/${item}`);
                break;
        }
    }

    useEffect(() => {
        console.log('menu', menu);
        console.log('item', item);
        console.log('key', key);
        console.log('factory', factory);
        if (key && factory && item && menu) {
            setIsLoading(true);
            const authData = {
                access_token: key,
                status: "success",
            };
            dispatch(setAuth(authData));
            getFactoryByAdmin({ factory_id: factory as string, product_id: item as string }).then((resFactory) => {
                console.log("resFactory", resFactory);
                const factoryData = resFactory.data;
                const factory = Array.isArray(factoryData) ? factoryData[0] : factoryData;
                getAuthProfile().then((res) => {
                    if (res.status === "success") {
                        const contactData = {
                            id: factory.id ?? factory.factory_id,
                            name: factory.name ?? factory.factory_name,
                            contact_name: factory.name ?? factory.factory_name,
                            use_platform_transport: factory.use_platform_transport,
                            sell_through_line: factory.sell_through_line,
                        }
                        dispatch(setProfileAndContact({
                            profile: res.profile,
                            contact: contactData
                        }
                        ));
                    }
                    handlePage(menu, item);
                }).catch((error) => {
                    console.error("Error getting auth profile:", error);
                    setIsLoading(false);
                });
            }).catch((error) => {
                console.error("Error getting factory by admin:", error);
                setIsLoading(false);
            });

        }
    }, [key, factory, item, menu, dispatch, navigate]);

    useEffect(() => {
        localStorage.removeItem("accessToken");
    }, []);

    if (isLoading) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                width: '100%'
            }}>
                <Spin size="large" />
                <p style={{ marginTop: 16, fontSize: 16, color: '#666' }}>กำลังโหลดข้อมูล...</p>
            </div>
        );
    }

    return (
        <div>
            {/* <h1>AuthAdmin</h1>
            <p>Key: {key}</p>
            <p>Factory: {factory}</p>
            <p>Item: {item}</p> */}
        </div>
    );
};
export default AuthAdmin;